/** Round x up to a "nice" 1/2/5 × 10^n value (for axis step sizing). */
function niceStep(x: number): number {
  if (x <= 0) return 1;
  const exp = Math.floor(Math.log10(x));
  const f = x / 10 ** exp;
  const nf = f <= 1 ? 1 : f <= 2 ? 2 : f <= 5 ? 5 : 10;
  return nf * 10 ** exp;
}

/** Build an axis max + ascending tick values (~5 gridlines) for a data max. */
export function niceScale(maxValue: number): { axisMax: number; ticks: number[] } {
  const safeMax = maxValue > 0 ? maxValue : 1;
  const step = niceStep(safeMax / 5);
  let axisMax = Math.ceil(safeMax / step) * step;
  // Guarantee headroom above the tallest bar so its % label never collides
  // with the top gridline.
  if (axisMax <= safeMax) axisMax += step;
  const ticks: number[] = [];
  for (let t = 0; t <= axisMax + 1e-9; t += step) ticks.push(Math.round(t));
  return { axisMax, ticks };
}
